import React from 'react';

export default ({
    hasSpouse,
    principalName,
    spouseName,
}) => {
    return <li className={hasSpouse ? "has-spouse" : ""}>
        <div>
            <div>
                <span>{principalName}'s Age</span>
                {hasSpouse && <span>{spouseName}'s Age</span>}
            </div>
        </div>
    </li>;
};